import React, { useState } from 'react';
import { Images } from '../../constants';


const ServiceCard = ({ name,description,image, index }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    
        <div 
          className='relative bg-[#ffffff] p-5 m-5 lg:m-0 rounded-lg border-gray-500 border '
          key={index}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {image ? (
        <img className='bg-[#0C2D57] p-1 rounded-md justify-center' src={image} alt={name} />
      ) : (
        <img className='bg-[#0C2D57] p-1 rounded-md justify-center' src={Images.DEFAULT_SERVICE_IMAGE} alt={name} />
      )}
          <h1 className=' poppins-bold py-3'>{name}</h1>
          <p className='poppins-regular'>{description}</p>
          {isHovered && (
            <button className={`absolute inset-0 flex items-center justify-center  bg-[#0C2D57] text-white rounded-lg transition-opacity duration-300 ${
              isHovered ? 'opacity-100' : 'opacity-0'
            }`}>
              
              View Details
            </button>
          )}
        </div>
      
  );
};

export default ServiceCard;
